import React, {useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import AppContentView from '@crema/core/AppContentView';
import {useAuthUser} from '../../utility/AuthHooks';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '../../utility/AppContextProvider/LayoutContextProvider';
import Layouts from './Layouts';
import AuthWrapper from './AuthWrapper';
import {useUrlSearchParams} from 'use-url-search-params';
import {useSidebarActionsContext} from '../../utility/AppContextProvider/SidebarContextProvider';

const AGREEMENT_PENDING_STATUSES = ['pending', 'uploaded', 'rejected'];

const AppLayout = () => {
  const {navStyle} = useLayoutContext();
  const {isAuthenticated, user} = useAuthUser();
  const {updateNavStyle} = useLayoutActionsContext();
  const {updateMenuStyle, setSidebarBgImage} = useSidebarActionsContext();
  const AppLayout = Layouts[navStyle];
  const [params] = useUrlSearchParams();
  const location = useLocation();

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, [
    params.layout,
    params.menuStyle,
    params.sidebarImage,
    setSidebarBgImage,
    updateMenuStyle,
    updateNavStyle,
  ]);

  const isPendingAgreementUser =
    isAuthenticated &&
    AGREEMENT_PENDING_STATUSES.includes(user?.agreement_status);
  const isOnPendingAgreementPage = location.pathname === '/pending-agreement';

  return (
    <>
      {!isAuthenticated ? (
        <AuthWrapper>
          <AppContentView />
        </AuthWrapper>
      ) : isPendingAgreementUser ? (
        isOnPendingAgreementPage ? (
          <AuthWrapper>
            <AppContentView />
          </AuthWrapper>
        ) : (
          <Navigate to='/pending-agreement' replace />
        )
      ) : (
        <AppLayout />
      )}
    </>
  );
};

export default React.memo(AppLayout);
